// @flow

import { createSelectorCreator, defaultMemoize } from 'reselect';
import isShallowEqualArray from 'shallow-equal/arrays';

const isEqualEntity = (a, b) => {
  if (Array.isArray(a) && Array.isArray(b)){
    return isShallowEqualArray(a, b);
  } else {
    return a === b;
  }
};

// create a selector that shallowly compares array arguments
export const createShallowEqualSelector = createSelectorCreator(
  defaultMemoize,
  isEqualEntity
);

// First pass, lets us return a function that is either
// a) A memoized selector (when called with arguments)
// b) A selector factory (when called with no arguments)
// Useful to enable users to run find('thing')(state, id) and get stuff back,
// but also to let query/join run find('thing')() and get a new selector instance, to be called later
/*
const createLazySelector = (args, func, createSelector = createSelectorDefault) => {
  let selector;
  return (...selector_args: Array<*>) => {
    if (selector_args.length > 0){
      selector = selector || createSelector(args, func);
      return selector(...selector_args);
    } else {
      return createSelector(args, func);
    }
  };
};
*/
